import { useState } from "react";
import { WhatsappLogo, X, Phone } from "@phosphor-icons/react";
import { COMPANY, waLink } from "@/data/company";

export default function FloatingWhatsApp() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="floating-whatsapp">
      {open && (
        <div className="mb-3 w-72 bg-white border-2 border-slate-900 shadow-brutal p-4">
          <div className="flex items-center justify-between mb-3">
            <div>
              <div className="font-display font-black text-slate-900">
                Chat with an owner
              </div>
              <div className="text-xs uppercase tracking-widest text-slate-500">
                Usually replies in minutes
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              data-testid="floating-wa-close"
              className="w-8 h-8 border-2 border-slate-900 flex items-center justify-center hover:bg-slate-900 hover:text-white transition-brutal"
              aria-label="Close"
            >
              <X size={14} weight="bold" />
            </button>
          </div>
          <div className="space-y-2">
            {COMPANY.owners.map((o) => (
              <div key={o.name} className="flex items-center justify-between gap-2 p-2 bg-[#F1F5F9] border border-slate-300">
                <div>
                  <div className="font-bold text-sm text-slate-900">{o.name}</div>
                  <div className="text-xs font-mono text-slate-600">{o.phone}</div>
                </div>
                <div className="flex items-center gap-1">
                  <a
                    href={`tel:${o.phone}`}
                    data-testid={`floating-call-${o.name.split(" ")[0].toLowerCase()}`}
                    className="w-9 h-9 bg-[#EA580C] text-white flex items-center justify-center border-2 border-slate-900 hover:bg-[#C2410C] transition-brutal"
                    aria-label={`Call ${o.name}`}
                  >
                    <Phone size={14} weight="bold" />
                  </a>
                  <a
                    href={waLink(o)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`floating-wa-${o.name.split(" ")[0].toLowerCase()}`}
                    className="w-9 h-9 bg-[#25D366] text-white flex items-center justify-center border-2 border-slate-900 hover:bg-[#128C7E] transition-brutal"
                    aria-label={`WhatsApp ${o.name}`}
                  >
                    <WhatsappLogo size={16} weight="bold" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="floating-wa-toggle"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center border-2 border-slate-900 shadow-brutal hover-shadow-brutal transition-brutal"
        aria-label="Chat on WhatsApp"
      >
        <WhatsappLogo size={26} weight="fill" />
      </button>
    </div>
  );
}
